import React, { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import Button from '@mui/material/Button';
import {
    Grid2 as Grid,
    DialogTitle,
    DialogContent,
    Tooltip,
    ButtonGroup,
    TextField,
    Chip
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';



import { AddCircle, CheckBox, RemoveCircle, Save, Add, Edit, Delete } from '@mui/icons-material';

import { useSearchParams } from 'react-router-dom';
import { makeid, myTimestampToDate } from '../utils/ui_utils';
import { LoadingButton } from '@mui/lab';
import { useAuth } from '../core/AuthProvider';
import { add_award_template, edit_award_template } from '../FirebaseUtils/dbSettings';
import { AwardDialog } from './AwardDialog';
import DeleteconfirmationSection from '../components/DeleteConfirmationSection';

import { globalstyles } from '../lib/definitions';
import { award_filter_subdict } from '../definitions/match';

const newtemplate_award = {
    name: '',
    award_list: []
}




export const TemplateAwardDialog = forwardRef(({ event_id, reloadFn }, ref) => {
    const { user } = useAuth()
    const dialogRef = useRef()
    const childRefDelete = useRef()
    const [open, setOpen] = useState(false);
    const [curElement, setCurElement] = useState({ ...newtemplate_award })
    const [isEdited, setIsEdited] = useState(false)
    const [isSaving, setIsSaving] = useState(false)
    const [isInvalid, setIsInvalid] = useState(false)
    const [showAdvance, setShowAdvance] = useState(false)
    const [is_new, setIsNew] = useState(false)
    const [index, setIndex] = useState(-1)
    const [searchParams, setSearchParams] = useSearchParams()






    useImperativeHandle(ref, () => {
        return {
            onNew() {
                setCurElement({ ...newtemplate_award, template_award_code: makeid(8, true) })
                setIndex(-1)
                setIsNew(true)
                setIsEdited(false)
                setOpen(true);
            },
            onEdit(el, i, is_c) {
                console.log("IS CURRENT",el,  is_c)
                setOpen(true);
                setIsNew(false)
                let _el = { ...newtemplate_award, ...el }
                setCurElement(_el)
                setIndex(i)
                setIsEdited(false)
            }
        }
    })


    const handleClose = () => {
        setSearchParams({})
        setOpen(false);
    };


    const handleSave = () => {
        if (is_new) {
            add_award_template(user.uid, curElement)
            reloadFn()
        } else {
            edit_award_template(user.uid, curElement.id, curElement)
            reloadFn(curElement)
        }
        setOpen(false)
    }



    const onChangeHandler = (el, level) => {
        let { name, value, type } = el
        console.log(el)
        console.log(name, value, type)
        if (type === 'radio') {
            if (value === 'true') {
                value = true
            } else if (value === 'false') {
                value = false
            }
        } else if (type === 'checkbox') {
            value = el.checked

        }
        if (value !== undefined) {
            setCurElement({ ...curElement, [name]: value })
            setIsEdited(true)
        }
    }


    const addFn = (c) => {
        setCurElement(e => {
            let c_list = [...e.award_list]
            c_list.push(c)
            return { ...e, award_list: c_list }
        })
    }

    const editFn = (c, i) => {
        setCurElement(e => {
            let c_list = [...e.award_list]
            c_list.splice(i, 1, c)
            return { ...e, award_list: c_list }
        })

    }
    const handleNew = () => {
        dialogRef.current.onNew()
    }

    const handleEdit = (r, i) => {
        console.log("EDIT", r)
        dialogRef.current.onEdit(r, i)
    }

    const handleDelete = (r, i) => {
        const cb = () => {
            setCurElement(e => {
                let c_list = [...e.award_list]
                c_list.splice(i, 1)
                return { ...e, award_list: c_list }

            })
        }
        childRefDelete.current.confirmDelete('Cancella premio', `Sei sicuro di voler cancellare la il premio: <b>${r.award_name}</b>`, cb)
    }



    useEffect(() => {
        return () => {

        }

    }, [])



    return (
        <div>

            <Dialog open={open} onClose={handleClose} maxWidth="xl" fullWidth={true}>
                <DeleteconfirmationSection ref={childRefDelete} />
                <AwardDialog ref={dialogRef} reloadFn={reloadFn} addFn={addFn} editFn={editFn} />
                <DialogTitle>
                    Template premio :  <b>{curElement.name}</b>
                </DialogTitle>
                <DialogContent>
                    <TextField
                        margin="dense"
                        id="name"
                        label={'Nome template'}
                        fullWidth
                        name="name"
                        variant="standard"
                        value={curElement.name}
                        onChange={(ev) => onChangeHandler(ev.target)}
                    />
                    <Grid container spacing={2} sx={{ background: 'lightblue', p: 0.5, borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                        <Grid size={2} sx={{ fontSize: '1.2em', fontWeight: 'bold' }}>
                            Lista categorie
                        </Grid>
                        <Grid size={"auto"}>

                        </Grid>
                    </Grid>
                    <Grid container sx={globalstyles.listHeader}>
                        <Grid size={"grow"}>
                            nome
                        </Grid>
                        <Grid size={"grow"}>
                            usa posizione
                        </Grid>
                        <Grid size={"grow"}>
                            punti assegnati
                        </Grid>
                        <Grid size={"grow"}>
                            filtro
                        </Grid>
                    </Grid>

                    <Grid >
                        {curElement.value?.map((a, k) => (
                            <Grid key={k} container sx={globalstyles.list_row}>
                                <Grid size={"grow"} sx={{ fontWeight: 'bold' }}>
                                    {a.award_name}
                                </Grid>
                                <Grid size={"grow"}>
                                    {a.has_position &&
                                        <>
                                            <CheckBox />
                                        </>}
                                </Grid>
                                <Grid size={"grow"}>
                                    {a.point_list?.map((p, kk) => (
                                        <Chip key={kk} size="small" label={p} />
                                    ))}
                                </Grid>
                                <Grid size={"grow"}>
                                    {a.filter_data_list?.sort().map((f, k) => (
                                        <Chip key={k} label={award_filter_subdict[f]?.label} color={award_filter_subdict[f]?.color} size="small" />
                                    ))}
                                </Grid>
                                <Grid size={"auto"}>
                                    <ButtonGroup size="small">
                                        <Button color="warning" onClick={() => handleEdit(a, k)} startIcon={<Edit />}></Button>
                                        <Button color="error" onClick={() => handleDelete(a, k)} startIcon={<Delete />}></Button>
                                    </ButtonGroup>
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' key={'bc'} onClick={handleClose}>Chiudi</Button>
                    {isEdited &&
                        <LoadingButton key={'bs'} disabled={isInvalid} onClick={handleSave} startIcon={<Save />} variant="contained" color="secondary" loading={isSaving} loadingPosition="start">Salva</LoadingButton>
                    }
                </DialogActions>
            </Dialog>
        </div>
    );
})
